<template>
  <div class="sum">
    <slot></slot>
    <div v-if="num_up">
      <p v-if="num || num === 0" class="data font_32_black">
        {{num}}
        <span
          v-if="this.rate_up && this.rate_up != 0 || this.rate_down && this.rate_down != 0"
          class="rate_down"
          v-bind:class="{font_12_red: rate_down, font_12_green: rate_up}"
        >
          <img v-if="rate_up" src="@/assets/icons/up@2x.png" alt />
          <img v-else src="@/assets/icons/down@2x.png" alt />
          <span>{{rate_up || rate_down}}</span>
        </span>
      </p>
      <p v-if="amount || amount === 0" class="data font_32_black">
        <span class="font_14_black">￥</span>
        {{amount}}
        <span
          v-if="this.rate_up && this.rate_up != 0 || this.rate_down && this.rate_down != 0"
          class="rate_down"
          v-bind:class="{font_12_red: rate_down, font_12_green: rate_up}"
        >
          <img v-if="rate_up" src="@/assets/icons/up@2x.png" alt />
          <img v-else src="@/assets/icons/down@2x.png" alt />
          <span>{{rate_up || rate_down}}</span>
        </span>
      </p>
      <p class="font_14_gray">{{title}}</p>
    </div>
    <div v-else>
      <p class="font_14_gray">{{title}}</p>
      <p v-if="num || num === 0" class="data font_24_black">
        {{num}}
        <span
          v-if="this.rate_up && this.rate_up != 0 || this.rate_down && this.rate_down != 0"
          class="rate_down"
          v-bind:class="{font_12_red: rate_down, font_12_green: rate_up}"
        >
          <img v-if="rate_up" src="@/assets/icons/up@2x.png" alt />
          <img v-else src="@/assets/icons/down@2x.png" alt />
          <span>{{rate_up || rate_down}}</span>
        </span>
      </p>
      <p v-if="amount || amount === 0" class="data font_24_black">
        <span class="font_14_black">￥</span>{{amount}}<span
          v-if="this.rate_up && this.rate_up != 0 || this.rate_down && this.rate_down != 0"
          class="rate_down"
          v-bind:class="{font_12_red: rate_down, font_12_green: rate_up}"
        >
          <img v-if="rate_up" src="@/assets/icons/up@2x.png" alt />
          <img v-else src="@/assets/icons/down@2x.png" alt />
          <span>{{rate_up || rate_down}}</span>
        </span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    title: String,
    num:  Number,
    amount: undefined,
    num_up: Boolean,
    rate_up: String,
    rate_down: String
  },
  data() {
    return {
      // rate: this.rate_up || this.rate_down,
      ifRate: this.rate_up && this.rate_up != 0 || this.rate_down && this.rate_down != 0,
    };
  },
  watch: {},
  computed: {
    rate() {
      return this.rate_up || this.rate_down
    },
  },
  methods: {},
  created() {},
  mounted() {
  }
};
</script>
<style lang="scss" scoped>
.sum {
  display: flex;
  align-items: center;
  p {
    margin: 0;
  }
}
.icon {
  width: 44px;
  height: 44px;
  margin-right: 14px;
}
.rate_up {
  vertical-align: top;
  span {
    transform: scale(0.84, 0.84);
  }
}
.rate_down {
  vertical-align: top;
  span {
    transform: scale(0.84, 0.84);
  }
}
</style>